import { importScheduleDialogViewState } from "../";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setImportScheduleInProgress", function setImportScheduleInProgress(inProgress: boolean) {
    importScheduleDialogViewState().importScheduleInProgress = inProgress;
});